//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ClientProfileNameLabel from "@Broker/@Modules/clients/board/client-profile/components/shared/client-profile-name-label.vue";
import TimelineItemCard from "../utils/timeline-card.vue";
import ChangelogMixin from "@Broker/@Modules/clients/board/client-profile/mixins/changelog-mixin.js";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ChangelogMerge",
  components: {
    TimelineItemCard,
    ClientProfileNameLabel
  },
  mixins: [ChangelogMixin],
  props: {
    value: {
      type: null,
      required: true
    },
    operation: {
      type: String,
      required: true
    },
    field: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    userDetails: {
      type: Object,
      required: true
    },
    insertionTimestamp: {
      type: String,
      required: true
    }
  },
  computed: {
    options() {
      return this.value.options;
    }
  },
  methods: {
    parseMergeOption(option) {
      return {
        0: this.value.from,
        1: this.value.to,
        2: {
          givenName: this.$t("global.words.both")
        }
      }[option];
    }
  }
});